import { findFirstNonEmptyString } from "@product/scmp-sdk";
import first from "lodash/first";
import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import { SCMPYoutubeVideo } from "scmp-app/components/scmp-youtube-video";
import { VideoPlayMode } from "scmp-app/components/scmp-youtube-video/enums";
import type { landingVideoVideo$key } from "scmp-app/queries/__generated__/landingVideoVideo.graphql";

import { BodyText, Container, Headline, TextContainer, TopicLabel, VideoContainer } from "./styles";

type Props = {
  reference: landingVideoVideo$key;
};

export const PostiesVideoLandingVideo: FunctionComponent<Props> = ({ reference: reference_ }) => {
  const video = useFragment<landingVideoVideo$key>(
    graphql`
      fragment landingVideoVideo on Video {
        entityId
        headline
        socialHeadline
        videoSource {
          id
          type
        }
        topics {
          name
        }
        body {
          text
        }
      }
    `,
    reference_,
  );

  const videoSource = first(video?.videoSource?.filter(item => item?.type === "youtube"));
  const videoId = videoSource?.id ?? "";

  const topic = first(video?.topics);
  const topicName = topic?.name ?? "";

  const headline = findFirstNonEmptyString(video?.socialHeadline, video?.headline);
  const bodyText = video?.body?.text ?? "";

  if (!videoId) return null;

  return (
    <Container>
      <VideoContainer>
        <SCMPYoutubeVideo
          enableAutoPlay={false}
          entityId={video.entityId}
          index={Number.parseInt(video.entityId)}
          initialVideoPlayMode={VideoPlayMode.Manual}
          isEnabledImaManager={false}
          isHeroVideo={false}
          isMuteVideo={false}
          title={headline}
          youtubeVideoId={videoId}
        />
      </VideoContainer>
      <TextContainer>
        <TopicLabel>{topicName}</TopicLabel>
        <Headline>{headline}</Headline>
        <BodyText>{bodyText}</BodyText>
      </TextContainer>
    </Container>
  );
};

PostiesVideoLandingVideo.displayName = "PostiesVideoLandingVideo";
